import formatters from '@/utils/formatters';

const mesesAbreviados = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];

const formatterYProdutividade = unidade => {
    return value => {
        if (!value) {
            return '-';
        }
        return formatters.formatNumber(value) + unidade;
    };
};

export const GRAFICO_PRODUTIVIDADE_OPTIONS = {
    legend: {
        onItemClick: {
            toggleDataSeries: true
        },
        formatter: (seriesName, opts) => {
            switch (opts.seriesIndex) {
                case 0:
                    return 'Produtividade estimada';
                // case 1:
                // 	return 'Produtividade última safra';
                // case 2:
                // 	return 'Produtividade média histórica';
                // case 1:
                // 	return 'Chuva';
            }
        }
    },
    chart: {
        toolbar: {
            show: false
        },
        zoom: {
            enabled: false
        }
    },
    dataLabels: {
        enabled: true,
        enabledOnSeries: [0]
    },
    plotOptions: {
        bar: {
            columnWidth: '5%'
        }
    },
    xaxis: {
        categories: []
    },
    colors: ['#FFA726', /* '#01A3A4', '#909399',  */ '#42A5F5'],
    stroke: {
        width: 2
        // dashArray: [0, 4, 4, 0]
    },
    yaxis: {
        seriesName: 'Produtividade estimada',
        title: {
            text: 'Produtividade (sc/ha)'
        },
        showAlways: true,
        forceNiceScale: true,
        decimalsInFloat: 0,
        min: 0
    },
    /* {
		seriesName: 'Produtividade estimada',
		show: false,
		title: {
			text: 'Produtividade (sc/ha)'
		}
	},
	{
		seriesName: 'Produtividade estimada',
		show: false,
		title: {
			text: 'Produtividade (sc/ha)'
		}
	},
	{
		showAlways: true,
		seriesName: 'Precipitação',
		opposite: true,
		title: {
			text: 'Chuva (mm)'
		}
	} */
    tooltip: {
        y: [
            {
                formatter: formatterYProdutividade('sc/ha')
            }
            /* {
				formatter: formatterYProdutividade('sc/ha')
			},
			{
				formatter: formatterYProdutividade('sc/ha')
			},
			{
				formatter: formatterYProdutividade('mm')
			} */
        ]
    }
};

export const GRAFICO_PLUVIOSIDADE_ACUMULADA = {
    legend: {
        onItemClick: {
            toggleDataSeries: true
        }
    },
    plotOptions: {
        bar: {
            columnWidth: '45%',
            endingShape: 'rounded'
        }
    },
    xaxis: {
        categories: mesesAbreviados,

        labels: {
            rotate: -45
        }
    },
    chart: {
        toolbar: {
            show: false
        }
    },
    colors: [
        '#ADD8E6',
        '#87CEEB',
        '#87CEFA',
        '#00BFFF',
        '#1E90FF',
        '#00CED1',
        '#4682B4'
    ],
    stroke: {
        curve: 'smooth',
        width: 2
    },
    yaxis: [
        {
            showAlways: true,
            title: {
                text: 'Chuva (mm)'
            },
            labels: {
                formatter: value => {
                    return value.toFixed(0);
                }
            },
            decimalsInFloat: 0
        }
    ],
    tooltip: {
        y: {
            formatter: value => {
                return formatters.formatNumber(value) + ' mm';
            }
        }
    }
};

export const GRAFICO_TEMPERATURA = {
    legend: {
        onItemClick: {
            toggleDataSeries: true
        }
    },
    plotOptions: {
        bar: {
            columnWidth: '45%',
            endingShape: 'rounded'
        }
    },
    chart: {
        toolbar: {
            show: false
        }
    },
    xaxis: {
        categories: mesesAbreviados
    },
    colors: [
        '#FFA500',
        '#FF8C00',
        '#FF6347',
        '#FFA07A',
        '#FA8072',
        '#B22222',
        '#D2691E'
    ],
    stroke: {
        curve: 'smooth',
        width: 2
    },
    yaxis: [
        {
            showAlways: true,
            title: {
                text: 'Temperatura (°C)'
            },
            labels: {
                formatter: value => {
                    return value.toFixed(0);
                }
            }
        }
    ],
    tooltip: {
        y: {
            formatter: value => {
                return formatters.formatNumber(value) + ' °C';
            }
        }
    }
};

export const GRAFICO_MONITORAMENTO_NDVI = {
    legend: {
        onItemClick: {
            toggleDataSeries: true
        }
    },
    chart: {
        toolbar: {
            show: false
        }
    },
    plotOptions: {
        bar: {
            columnWidth: '10%'
        }
    },
    xaxis: {
        categories: []
    },
    colors: ['#D6D951', '#889306', '#63AF01'],
    stroke: {
        width: 2
    },
    yaxis: [
        {
            seriesName: 'Índice de vegetação',
            title: {
                text: 'Índice de vegetação'
            },
            showAlways: true,
            forceNiceScale: true,
            labels: {
                formatter: value => {
                    return formatters.formatNumber(value, 1);
                }
            }
        } /* ,
	{
		showAlways: true,
		seriesName: 'Chuva',
		opposite: true,
		title: {
			text: 'Chuva (mm)'
		}
	} */
    ],
    tooltip: {
        y: [
            {
                formatter: value => {
                    return formatters.formatNumber(value, 2);
                }
            } /* ,
			{
				formatter: formatterYProdutividade('mm')
			} */
        ]
    }
};

export const GRAFICO_PREVISAO_CHUVA_TEMPERATURA = {
    stroke: {
        show: true,
        width: 2,
        curve: 'smooth'
    },
    chart: {
        toolbar: {
            show: false
        }
    },
    colors: ['#2688d5', '#ffc107', '#58d6a7'],
    /* dataLabels: {
		enabled: true,
		enabledOnSeries: [0]
	}, */
    xaxis: {},
    yaxis: [
        {
            seriesName: 'Precipitação',
            title: {
                text: 'Precipitação (mm)'
            }
        },
        {
            seriesName: 'Temperatura máxima',
            opposite: true,
            forceNiceScale: true,
            title: {
                text: 'Temperatura (ºC)'
            }
        },
        {
            seriesName: 'Temperatura mínima',
            opposite: true,
            forceNiceScale: true,
            title: {
                text: 'Temperatura (ºC)'
            },
            show: false
        }
    ],
    plotOptions: {
        bar: {
            columnWidth: '50%'
        }
    },
    tooltip: {
        y: [
            {
                formatter(value) {
                    return formatters.formatNumber(value) + ' mm';
                }
            },
            {
                formatter(value) {
                    return formatters.formatNumber(value) + ' °C';
                }
            },
            {
                formatter(value) {
                    return formatters.formatNumber(value) + ' °C';
                }
            }
        ]
    }
};
